module.exports = __webpack_public_path__ + "img/atten.cf743260.png";